<template>
  <div class="page">
    <div
      style="position:absolute; top:30px; right:40px;"
    >PAGE: {{invoice.pageIndex}} / {{invoice.total.value}}</div>
    <div style="text-align:center;margin-top:15px;">
      <h1
        style="border-bottom:1px solid #000;line-height:30px;display:inline-block;"
      >INVOICE ATTACHMENT</h1>
    </div>
    <div style="width:100%;text-align:right;">
      <span
        style="display:inline-block;width:120px;text-align:right;padding-right:15px;"
      >INVOICE NO:</span>
      <span style="display:inline-block;width:120px;text-align:left;">{{invoice.invoiceNo}}</span>
    </div>
    <div style="width:100%;text-align:right;">
      <span
        style="display:inline-block;width:120px;text-align:right;padding-right:15px;"
      >INVOICE DATE:</span>
      <span style="display:inline-block;width:120px;text-align:left;">{{invoice.creationDate}}</span>
    </div>
    <div class="list">
      <div class="row" style="height:50px;border-top:1px solid #000;border-bottom:1px solid #000;">
        <div style="left:0px;top:5px;">P/C No.</div>
        <div style="left:100px;top:5px;">P/O No.</div>
        <div style="left:200px;top:5px;">S/R No.</div>
        <div style="left:300px;top:5px;">LOT NO.</div>
        <div style="left:400px;top:5px;">DESCRIPTION</div>
        <div style="left:0px;top:25px;">EXTERNAL NAME</div>
        <div style="left:210px;top:25px;">INTERNAL NAME</div>
        <div style="right:300px;top:25px;">QUANTITY</div>
        <div style="right:150px;top:25px;">UNIT PRICE(US$)</div>
        <div style="right:0px;top:25px;">AMOUNT(US$)</div>
      </div>
    </div>
    <div
      :key="item.id"
      class="row"
      style="height:80px; border-bottom:1px solid #000;"
      v-for="item in invoice.items"
    >
      <div style="left:0px;top:5px;">COUNTRY OF ORIGIN : {{item.originCountryName}}</div>
      <div style="left:0px;top:30px;">{{item.productCode}}</div>
      <div style="left:100px;top:30px;">{{item.poNo}}</div>
      <div style="left:200px;top:30px;">{{item.srNo}}</div>
      <div style="left:300px;top:30px;">{{item.lotNo}}</div>
      <div style="left:400px;top:30px;">{{item.productName}}</div>
      <div style="left:0px;top:55px;">{{item.skuCode}}</div>
      <div style="left:210px;top:55px;">{{item.skuCode}}</div>
      <div style="right:300px;top:55px;">{{item.qty|currency({fractionCount:2})}}(PC)</div>
      <div style="right:150px;top:55px;">{{item.unitPrice|currency({fractionCount:4})}}</div>
      <div style="right:0px;top:55px;">{{item.subTotal|currency({fractionCount:2})}}</div>
    </div>
    <div class="row" style="height:30px;" v-if="invoice.pageIndex===invoice.total.value">
      <div style="left:0px;top:5px;">TOTAL:</div>
      <div style="right:600px;top:5px;">{{invoice.totalCartonQty|currency({fractionCount:0})}}CTN(S)</div>
      <div style="right:300px;top:5px;">{{invoice.totalQty|currency({fractionCount:2})}}(PC)</div>
      <div style="right:0px;top:5px;">US${{invoice.totalAmount|currency({fractionCount:2})}}</div>
    </div>
  </div>
</template>
<script>
export default {
  props: ['invoice']
}
</script>
<style scoped>
.page {
  padding: 30px 30px;
}
.contract-info {
  width: 100%;
}
.contract-info td {
  vertical-align: top;
  word-wrap: normal !important;
  padding: 5px 3px;
}
.list {
  width: 100%;
}
.row {
  width: 100%;
  position: relative;
}
.row > div {
  position: absolute;
}
</style>